module.exports = __webpack_public_path__ + "img/do.454b6dbd.svg";